import { get, post } from "@/utils/http";

let baseURL = "/meetroom";

// 获取会议室列表
const findAll = data => get(`${baseURL}/findAll`, data);

// 添加或编辑会议室信息
const addAndEditRooms = data => post(`${baseURL}/addAndEditRoom`, { data });

// 删除会议室信息
const deleteRoom = data => post(`${baseURL}/deleteRoom`, { data });

// 锁定会议室
const lockMeetingRoom = data => post(`${baseURL}/lockMeetingRoom`, { data });

//获取会议室信息
const getMeetingRoomList = data =>get(`${baseURL}/getMeetingRoomList`, data);

//预约会议室
const addMeetingRoomsInfo = data =>post(`${baseURL}/addMeetingRoomsInfo`, { data })

const getLockDate = data => get(`${baseURL}/getLockDate`, data);

// API
export default {
  findAll,
  addAndEditRooms,
  deleteRoom,
  getMeetingRoomList,
  addMeetingRoomsInfo,
  lockMeetingRoom,
  getLockDate
};
